import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WholeSyncableVtmFragment = { readonly __typename?: 'SyncableVtm', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly productType: Types.ProductType, readonly snomedId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } };

export type SyncVtmPullQueryVariables = Types.Exact<{
  input: Types.PullVtmInput;
}>;


export type SyncVtmPullQuery = { readonly __typename?: 'Query', readonly pullVtm: { readonly __typename?: 'PullVtmResponse', readonly checkpoint?: { readonly __typename?: 'SyncableCheckpoint', readonly id: string, readonly updatedAt: string } | null, readonly documents: ReadonlyArray<{ readonly __typename?: 'SyncableVtm', readonly id: string, readonly title: string, readonly keywords: ReadonlyArray<string>, readonly productType: Types.ProductType, readonly snomedId?: string | null, readonly meta: { readonly __typename?: 'SyncableMeta', readonly createdAt: string, readonly createdByUserId: string, readonly updatedAt: string, readonly updatedByUserId: string, readonly deleted: boolean } }> } };

export const WholeSyncableVtmFragmentDoc = gql`
    fragment WholeSyncableVtm on SyncableVtm {
  id
  title
  keywords
  productType
  snomedId
  meta {
    createdAt
    createdByUserId
    updatedAt
    updatedByUserId
    deleted
  }
}
    `;
export const SyncVtmPullDocument = gql`
    query SyncVtmPull($input: PullVtmInput!) {
  pullVtm(input: $input) {
    checkpoint {
      id
      updatedAt
    }
    documents {
      ...WholeSyncableVtm
    }
  }
}
    ${WholeSyncableVtmFragmentDoc}`;

/**
 * __useSyncVtmPullQuery__
 *
 * To run a query within a React component, call `useSyncVtmPullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSyncVtmPullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSyncVtmPullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncVtmPullQuery(baseOptions: Apollo.QueryHookOptions<SyncVtmPullQuery, SyncVtmPullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SyncVtmPullQuery, SyncVtmPullQueryVariables>(SyncVtmPullDocument, options);
      }
export function useSyncVtmPullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SyncVtmPullQuery, SyncVtmPullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SyncVtmPullQuery, SyncVtmPullQueryVariables>(SyncVtmPullDocument, options);
        }
export type SyncVtmPullQueryHookResult = ReturnType<typeof useSyncVtmPullQuery>;
export type SyncVtmPullLazyQueryHookResult = ReturnType<typeof useSyncVtmPullLazyQuery>;
export type SyncVtmPullQueryResult = Apollo.QueryResult<SyncVtmPullQuery, SyncVtmPullQueryVariables>;